import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { MyCompanyPanelDataProviderFactory } from '../factory/MyCompanyPanelDataProviderFactory';
import { MyCompanyPanelBaseDataProvider } from '../dataProvider/MyCompanyPanelBaseDataProvider';
import { CompanyData } from '../../../types/company-data';
import { User } from '../../../types/user';

export class MyCompanyPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MyCompanyPanelDataProviderFactory;
  public dataProvider: MyCompanyPanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MyCompanyPanelDataProviderFactory(),
    });
  }

  public async getMyCompanyData(): Promise<CompanyData> {
    return this.dataProvider.getMyCompanyData();
  }

  public async getLoggedUser(): Promise<User> {
    return this.dataProvider.getLoggedUser();
  }
}
